module.exports = __webpack_public_path__ + "img/kc13.c16f7adc.png";